import React from "react";
import { CFormLabel, CFormSelect } from "@coreui/react";

export default function RestaurantGroupSelect({
  groups,
  value,
  onChange,
  disabled,
  className = "",
  id = "restaurantGroupSelect",
}) {
  const list = Array.isArray(groups) ? groups : [];
  if (!list.length) return null;

  return (
    <div className={className}>
      <CFormLabel htmlFor={id} className="small text-body-secondary mb-1">
        Группа ресторанов
      </CFormLabel>
      <CFormSelect
        id={id}
        aria-label="Группа ресторанов"
        value={value ?? ""}
        disabled={disabled || list.length === 0}
        onChange={(e) => onChange(e.target.value)}
      >
        {list.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </CFormSelect>
    </div>
  );
}
